﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AstraLeftNavBar = void 0;
const gs = require("@ivanlog/gs");
const com = require("./tmpls");
class AstraLeftNavBar extends com.LeftNavBar {
    constructor(app) {
        super();
        this.app = app;
        this._body = gs.q('body').first;
        this.ctrls.linkLogout.onclick = () => __awaiter(this, void 0, void 0, function* () { return yield app.auth.logout(); });
    }
    show() {
        this._body.addClass('with_left_bar');
        super.show();
    }
    hide() {
        this._body.removeClass('with_left_bar');
        super.hide();
    }
}
exports.AstraLeftNavBar = AstraLeftNavBar;
//# sourceMappingURL=AstraLeftNavBar.js.map